const saveSearchedItemInLocalStorage = (item) => {
  const searchedItems = localStorage.getItem("searchedItems")
    ? JSON.parse(localStorage.getItem("searchedItems"))
    : [];

  const bool = searchedItems.some((i) => i.name === item.name);
  if (!bool) {
    searchedItems.push(item);
    if (searchedItems.length > 5) {
      searchedItems.shift();
    }
  }

  localStorage.setItem("searchedItems", JSON.stringify(searchedItems));
};
const getSearchedItemsFromLocalStorage = () => {
  const items = JSON.parse(localStorage.getItem("searchedItems"));
  return items.reverse();
};

const saveLastVisitedRouteInLocalStorage = (path) => {
  let lastVisited = localStorage.getItem("lastVisited")
    ? JSON.parse(localStorage.getItem("lastVisited"))
    : [];
  lastVisited = [{ path: path }];

  localStorage.setItem("lastVisited", JSON.stringify(lastVisited));
};
const getLastVisitedRouteInLocalStorage = () => {
  const items = localStorage.getItem("lastVisited")
    ? JSON.parse(localStorage.getItem("lastVisited"))
    : null;
  if (items === null || items?.length < 0) return null;
  else if (items[0].path) return items[0].path;
  else return null;
};
export {
  saveSearchedItemInLocalStorage,
  getSearchedItemsFromLocalStorage,
  saveLastVisitedRouteInLocalStorage,
  getLastVisitedRouteInLocalStorage,
};
